var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswerCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 8.0329C15.582 11.9442 12.4113 15.1149 8.5 15.1149C4.58868 15.1149 1.41803 11.9442 1.41803 8.0329C1.41803 4.12158 4.58868 0.950928 8.5 0.950928C12.4113 0.950928 15.582 4.12158 15.582 8.0329Z",
    fill: "#65AA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9563 12.7702C8.53777 12.2181 8.89344 10.7086 8.89344 10.7086L7.9563 9.91137C7.9563 9.91137 6.70692 8.4416 6.71402 8.44721C4.14301 5.45156 6.08395 1.39002 6.10589 1.34424C3.37446 2.31639 1.41803 4.92906 1.41803 7.99926C1.41803 11.6331 4.1586 14.6258 7.68148 15.0164C7.22248 14.3198 7.32709 13.3678 7.9563 12.7702Z",
    fill: "#5F9E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75604 11.4754C7.53398 11.4754 7.31071 11.4051 7.12258 11.2614L4.18277 8.2715C3.72885 7.92501 3.64468 7.27982 3.99486 6.83053C4.34492 6.38136 4.99677 6.29804 5.45069 6.64453L7.63011 9.05405L11.2165 5.12545C11.6008 4.70447 12.2571 4.67153 12.6825 5.05204C13.1078 5.43233 13.1411 6.08203 12.7567 6.50301L8.52665 11.1368C8.32263 11.3602 8.04031 11.4754 7.75604 11.4754Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerCorrect);
export default __webpack_public_path__ + "static/media/answer_correct.dbb3b5b014aefd83b8c510013e09e923.svg";
export { ForwardRef as ReactComponent };